import axiosInstance from "./axiosInstance";

export const liberarFechas = async (
  titularId,
  numeroNochesA,
  numeroNochesB
) => {
  return await axiosInstance.post(
    `${process.env.REACT_APP_BASE_URL}/liberarFechas`,
    {
      titularId,
      numeroNochesA,
      numeroNochesB,
    },
    { withCredentials: true }
  );
};
